import React, { useEffect } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Tag } from 'components';
import { useMassLandingData } from 'hooks';

import './MasslandingBlock.scss';

export default function MasslandingBlock({ className }) {
    /**
     * Switch Product History Slider with MasslandingBlock
     * TODO : find a better way to do it
     */
    useEffect(() => {
        const productHistoryWrapper = document.getElementById(
            'wrapper-product-history',
        );
        const productHistory = document.getElementById('product-history');

        if (!productHistoryWrapper || !productHistory) return;
        productHistoryWrapper.appendChild(productHistory);
    }, []);

    const masslandingData = useMassLandingData();

    return masslandingData ? (
        <div className={className}>
            <h2 className="seo-blocks-links-title">
                <FormattedMessage
                    id="listing.masslandingBlocks.title"
                    defaultMessage="Discover also"
                    description="Masslanding seo blocks title"
                />
            </h2>
            {masslandingData.map(({ url, anchor = '' }, index) => (
                <li key={url} className="seo-blocks-links__related-item">
                    {/* eslint-disable react/no-array-index-key */}
                    <Tag
                        key={`${anchor}-${index}`}
                        label={anchor}
                        url={url}
                        className="seo-blocks-links__related-link"
                    />
                    {/* eslint-enable react/no-array-index-key */}
                </li>
            ))}
        </div>
    ) : null;
}

MasslandingBlock.propTypes = {
    className: string,
};

MasslandingBlock.defaultProps = {
    className: null,
};
